import { createSlice } from '@reduxjs/toolkit';

export type FmrsState = {
  isLoading: boolean;
  errors: null | [];
  data: {
    billingConsent: boolean;
    preferredStartDate: string | null;
  };
};

export const initialState: FmrsState = {
  isLoading: false,
  errors: null,
  data: {
    billingConsent: false,
    preferredStartDate: null
  }
};

export const slice = createSlice({
  name: 'fmrs',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state.isLoading = initialState.isLoading;
      state.errors = initialState.errors;
      state.data = initialState.data;
    },
    setBillingConsent: (state, { payload }) => {
      state.data.billingConsent = payload;
    },
    setPreferedStartDate: (state, { payload }) => {
      state.data.preferredStartDate = payload;
    }
  }
});

export const {
  setInitialState,
  setBillingConsent,
  setPreferedStartDate
} = slice.actions;

export const selectSlice = (state) => state[slice.name];
export const selectData = (state) => selectSlice(state).data;

export default slice.reducer;
